"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJsonSchema = void 0;
/**
 * Convert an io-ts codec to a JSON Schema (v7)
 *
 * @param _type - an io-ts codec
 * @param strict - whether to enable strict mode
 * @returns a JSON schema object
 * @see https://json-schema.org/understanding-json-schema/basics.html
 */
const toJsonSchema = (_type, strict = false) => {
    const type = _type;
    if (type._tag === 'StringType') {
        return { type: 'string' };
    }
    if (type._tag === 'NumberType') {
        return { type: 'number' };
    }
    if (type._tag === 'NullType') {
        return { type: 'null' };
    }
    if (type._tag === 'BooleanType') {
        return { type: 'boolean' };
    }
    if (type._tag === 'LiteralType') {
        return { const: type.value };
    }
    if (type._tag === 'KeyofType') {
        return { type: 'string', enum: Object.keys(type.keys) };
    }
    if (type._tag === 'UnionType') {
        return { anyOf: type.types.map((t) => (0, exports.toJsonSchema)(t, strict)) };
    }
    if (type._tag === 'IntersectionType') {
        return { allOf: type.types.map((t) => (0, exports.toJsonSchema)(t, strict)) };
    }
    if (type._tag === 'InterfaceType') {
        return {
            type: 'object',
            required: Object.keys(type.props),
            properties: Object.fromEntries(Object.entries(type.props).map(([key, subtype]) => [
                key,
                (0, exports.toJsonSchema)(subtype, strict),
            ])),
            ...(strict ? { additionalProperties: false } : {}),
        };
    }
    if (type._tag === 'DictionaryType') {
        return {
            type: 'object',
            additionalProperties: (0, exports.toJsonSchema)(type.codomain, strict),
        };
    }
    if (type._tag === 'PartialType') {
        return {
            type: 'object',
            properties: Object.fromEntries(Object.entries(type.props).map(([key, subtype]) => [
                key,
                (0, exports.toJsonSchema)(subtype, strict),
            ])),
            ...(strict ? { additionalProperties: false } : {}),
        };
    }
    if (type._tag === 'ArrayType') {
        return {
            type: 'array',
            items: (0, exports.toJsonSchema)(type.type, strict),
        };
    }
    if (type._tag === 'TupleType') {
        return {
            type: 'array',
            items: type.types.map((t) => (0, exports.toJsonSchema)(t, strict)),
        };
    }
    if (type._tag === 'RefinementType') {
        if (type.name === 'Int') {
            return { type: 'integer' };
        }
        return {
            ...(0, exports.toJsonSchema)(type.type, strict),
            description: `Predicate: ${type.predicate.name || type.name}`,
        };
    }
    // could add more here for DateFromISOString, etc. etc.
    return unhandledType(type);
};
exports.toJsonSchema = toJsonSchema;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
const unhandledType = (_shouldBeNever) => ({});
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable no-underscore-dangle */
//# sourceMappingURL=toJsonSchema.js.map